/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PopularQuestGame } from './PopularQuestGame';
import {
    PopularQuestGameFromJSON,
    PopularQuestGameFromJSONTyped,
    PopularQuestGameToJSON,
    PopularQuestGameToJSONTyped,
} from './PopularQuestGame';

/**
 * 
 * @export
 * @interface GetPopularQuestGamesResponse
 */
export interface GetPopularQuestGamesResponse {
    /**
     * 
     * @type {Array<PopularQuestGame>}
     * @memberof GetPopularQuestGamesResponse
     */
    games?: Array<PopularQuestGame>;
}

/**
 * Check if a given object implements the GetPopularQuestGamesResponse interface.
 */
export function instanceOfGetPopularQuestGamesResponse(value: object): value is GetPopularQuestGamesResponse {
    return true;
}

export function GetPopularQuestGamesResponseFromJSON(json: any): GetPopularQuestGamesResponse {
    return GetPopularQuestGamesResponseFromJSONTyped(json, false);
}

export function GetPopularQuestGamesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPopularQuestGamesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'games': json['games'] == null ? undefined : ((json['games'] as Array<any>).map(PopularQuestGameFromJSON)),
    };
}

export function GetPopularQuestGamesResponseToJSON(json: any): GetPopularQuestGamesResponse {
    return GetPopularQuestGamesResponseToJSONTyped(json, false);
}

export function GetPopularQuestGamesResponseToJSONTyped(value?: GetPopularQuestGamesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'games': value['games'] == null ? undefined : ((value['games'] as Array<any>).map(PopularQuestGameToJSON)),
    };
}

